'use strict';

var util = angular.module('gymsystem.util');

util.directive('economycertifyincomes', ['$rootScope', '$controller', '$modal', '$filter', 'server', function($rootScope, $controller, $modal, $filter, server) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $controller('EconomyCtrl', {$scope: $scope});

            $scope.loadingStatus = {};

            var rows = [
                { id: 'pendingInvoice', title: 'Unconfirmed invoices', payments: [] },
                { id: 'pendingDD', title: 'Unconfirmed direct debit invoices', payments: [] },
                { id: 'failedDD', title: 'Failed direct debit invoices', payments: [] }
            ];

            var getPayments = function() {
                server.post2('/api/payment/get_list', {
                    status: ['pending', 'failed'],
                    to_date: Date.today().addDays(25),
                    confirmed: false,
                    method: 'directdebit',
                    legal_entity_id: $rootScope.selectedSite.legal_entity_id
                }).then(function(result) {
                    $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                        result.forEach($rootScope.transformPayment);
                        result = $scope.bundleTogether(result, true);
                        result = result.filter(function(r) { return r.payer.consent; });

                        _.findWhere(rows, { id: 'pendingDD' }).payments = result.filter(function(p) { return p.method == 'directdebit' && p.status == 'pending'; });
                        _.findWhere(rows, { id: 'failedDD' }).payments = result.filter(function(p) { return p.method == 'directdebit' && p.status == 'failed'; });
                        $scope.config.control.update();
                    });
                });

                server.post2('/api/payment/get_list', {
                    status: 'pending',
                    to_date: Date.today().addDays(60),
                    confirmed: false,
                    method: ['invoice', 'einvoice'],
                    legal_entity_id: $rootScope.selectedSite.legal_entity_id
                }).then(function(result) {
                    $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                        result.forEach($rootScope.transformPayment);
                        result = $scope.bundleTogether(result, true);

                        _.findWhere(rows, { id: 'pendingInvoice' }).payments = result.filter(function(p) { return (p.method == 'invoice' || p.method == 'einvoice') && p.status == 'pending'; });
                        $scope.config.control.update();
                    });
                });
            };

            var getIds = function(payments) {
                var ids = [];
                angular.forEach(payments, function(payment) {
                    ids = ids.concat(_.pluck(payment.parts, 'id'));
                });
                return ids;
            };

            var allDDAboveMinAmount = function(payments) {
                if (!$scope.ddsettings || !$scope.ddsettings.minAmount) {
                    return true;
                }
                var minAmount = Number($scope.ddsettings.minAmount);
                var hasPaymentBelowMin = !!_.find(payments, function(p) { return p.amount < minAmount; });
                return !hasPaymentBelowMin;
            };
            var allInvoicesAboveMinAmount = function(payments) {
                if (!$scope.invsettings || !$scope.invsettings.minAmount) {
                    return true;
                }
                var minAmount = Number($scope.invsettings.minAmount);
                var hasPaymentBelowMin = !!_.find(payments, function(p) { return p.amount < minAmount; });
                return !hasPaymentBelowMin;
            };

            var confirmAll = function(row) {
                $scope.loadingStatus.loading = true;
                var payments = row.payments;

                var confirmPayments = function(delayBelowMin) {
                    var ids = getIds(payments);
                    server.post2('/api/payment/confirm', {payments: ids, delayBelowMin: !!delayBelowMin}, {
                        successAlert: 'Payments confirmed',
                        errorAlert: 'Failed to confirm payments'
                    }).then(function() {
                        $scope.loadingStatus.loading = false;
                        getPayments();
                    }, function() {
                        $scope.loadingStatus.loading = false;
                        getPayments();
                    });
                };

                var delay = function() { confirmPayments(true); };
                var skipDelay = function() { confirmPayments(false); };
                var f = row.id == 'pendingInvoice' ? allInvoicesAboveMinAmount : allDDAboveMinAmount;
                if (!f(payments)) {
                    $modal.open({
                        templateUrl: 'views/paymentconfirmationoptionmodal.html',
                        controller: 'PaymentConfirmationOptionModalCtrl',
                    }).result.then(function(result) {
                        if (result.delayBelowMin) { delay(); }
                        else { skipDelay(); }
                    }, function() {
                        $scope.loadingStatus.loading = false;
                    });
                } else {
                    skipDelay();
                }
            };

            var confirmDisabled = function(row) {
                return !row.payments.length;
            };

            var showAll = function(row) {
                $modal.open({
                    templateUrl: 'components/widgets/economycertifyincomes/confirmpaymentsmodal.html',
                    windowClass: 'huge-modal-window',
                    resolve: {
                        item: function() {
                            return row;
                        }
                    },
                    controller: ['$scope', '$controller', 'item', function($scope, $controller, item) {
                        $controller('EconomyCtrl', {$scope: $scope});
                        $scope.type = item.id;
                        $scope.title = item.title;
                    }]
                });
            };

            var getRowAmount = function(row) {
                return _.reduce(row.payments, function(sum, payment) { return sum + (payment.totalamount || payment.amount || 0); }, 0);
            };

            $scope.config = {
                getItems: function() {
                    return rows;
                },
                rowClick: showAll,
                hideSearch: true,
                columns: [
                    { field: 'title', title: 'Type', getValue: function(row) { return $filter('translate')(row.title); } },
                    { field: 'count', title: 'Count', getValue: function(row) { return row.payments.length; } },
                    { field: 'amount', title: 'Amount', getValue: getRowAmount }
                ],
                buttons: [
                    { title: 'Confirm all', buttonClass: 'btn-success', onClick: confirmAll, loading: function() { return $scope.loadingStatus.loading; }, disabled: confirmDisabled },
                    { title: 'Show', buttonClass: 'btn-info', onClick: showAll }
                ],
            };

            getPayments();

            function getDdSettings() {
                server.get('/api/directdebit/settings/get', { legal_entity_id: $rootScope.selectedSite.legal_entity_id }).then(function(data) {
                    $scope.ddsettings = data;
                });
            }
            getDdSettings();

            server.get('/api/invoice/settings/get').then(function(data) {
                $scope.invsettings = data;
            });

            $scope.pubsub('selectedSite', function() {
                getDdSettings();
                getPayments();
            });
        }
    };
}]);
